// CF Redeploy 02/01/2026 - Secrets Hidden

"use strict";
import DataManager from './src/managers/dataManager.js';
import MapManager from './src/managers/mapManager.js';
import MarkerManager from './src/managers/markerManager.js';
import ClusterHeatManager from './src/managers/clusterHeatManager.js';
import FilterManager from './src/managers/filterManager.js';
import UIManager from './src/managers/uiManager.js';
import AnimationManager from './src/managers/animationManager.js';
import URLManager from './src/managers/urlManager.js';
window.Webflow ||= [];
window.Webflow.push(() => {
    // ! Initialize Managers
    const dataManager = new DataManager();
    const mapManager = new MapManager();
    const animationManager = new AnimationManager();
    let markerManager;
    let clusterHeatManager;
    let filterManager;
    let uiManager;
    let urlManager; 
    // ! Initialize Map + Data
    async function initializeMap() {
        try {            
            await dataManager.fetchData();
            dataManager.processGeoData();
            // Initialize map with token from DataManager
            await mapManager.initialize(dataManager.mapboxToken);
            // Initialize MarkerManager (needs both map and data ready)
            markerManager = new MarkerManager(mapManager, dataManager);
            // Initialize ClusterHeatManager (needs both map and data ready)
            clusterHeatManager = new ClusterHeatManager(mapManager, dataManager);
            // Wait for map to fully load before adding layers and markers
            mapManager.onLoad(() => {
                // Add clustering and heatmap layers FIRST (loads before markers)
                clusterHeatManager.initialize();
                // Then add markers (heavier, loads after)
                markerManager.renderMarkers();
                // Set up coordinated zoom handler
                setupZoomCoordination();
                // Initialize FilterManager AFTER all visual components are ready
                setupFiltering();
            });
        } catch (error) {
            console.error('❌ Error during initialization:', error);
            throw error;
        }
    }
// ! Coordinate visibility between clusters/heatmap and markers based on zoom
    function setupZoomCoordination() {
        const map = mapManager.getMap();
        if (!map) return;
        map.on('zoom', () => {
            const currentZoom = map.getZoom();
            // Toggle cluster/heatmap visibility (visible < zoom 11)
            clusterHeatManager.toggleClustersVisibility(currentZoom);
            clusterHeatManager.toggleHeatmapVisibility(currentZoom);
            // MarkerManager handles its own visibility (visible >= zoom 11) through its internal zoom handler
        });
    }
// ! Filtering Setup
    function setupFiltering() {
        // Initialize UIManager first (handles all panel interactions)
        uiManager = new UIManager(mapManager, markerManager, dataManager);
        uiManager.initialize();
        // Initialize FilterManager with all required managers
        filterManager = new FilterManager(dataManager, markerManager, clusterHeatManager);
        // Connect UIManager with FilterManager for project item visibility updates
        uiManager.setFilterManager(filterManager);
        // Expose globally for debugging/advanced use
        window.filterManager = filterManager;
        window.dataManager = dataManager;
        window.uiManager = uiManager;
        window.animationManager = animationManager;
        // ! Invoking Setup Functions
        filterManager.setupTypologyFilters();
        filterManager.setupTypologyAllButton(); // "all" button for typologies
        filterManager.setupStatusFilters();
        filterManager.setupStatusAllButton(); // "all-status" button for statuses
        filterManager.setupClearAllFiltersButton(); // "clear-filters" button
        filterManager.setupVisibleCounter(); // "filter-count" element
        // !Initialize AnimationManager for mobile drag handles and animations
        animationManager.initialize();
        // ! Initialize URLManager for URL parameter handling and browser navigation
        urlManager = new URLManager(uiManager, markerManager, dataManager);
        urlManager.initialize();
        urlManager.hookIntoUIManager(); // Hook into project activation/deactivation
        window.urlManager = urlManager; // Expose for debugging
    }
// ! Initialize everything
    initializeMap();

});